/**
 * Admin Error Reporting Utility
 * Frontend version - logs errors to console and optionally sends to backend
 */

/**
 * Report error to admin (console log for now)
 * @param {string} message - Error message
 * @param {Error|string} error - Error object or string
 * @param {Object} context - Additional context
 */
export const reportError = async (message, error = null, context = {}) => {
  const timestamp = new Date().toISOString();
  
  // Log to console
  console.error(`[${timestamp}] ${message}`, {
    error: error?.message || error,
    stack: error?.stack,
    ...context
  });

  // TODO: Send to backend /api/admin/error-report if needed
  try {
    // Uncomment when backend error reporting endpoint is ready
    // await fetch('/api/admin/error-report', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     message,
    //     error: error?.message || String(error),
    //     stack: error?.stack,
    //     timestamp,
    //     ...context
    //   })
    // });
  } catch (reportingError) {
    console.error('Failed to report error:', reportingError);
  }
};

/**
 * Report success to admin (console log for now)
 * @param {string} message - Success message
 * @param {Object} data - Success data
 */
export const reportSuccess = (message, data = {}) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] ✅ ${message}`, data);
};

/**
 * Report info to admin (console log for now)
 * @param {string} message - Info message
 * @param {Object} data - Info data
 */
export const reportInfo = (message, data = {}) => {
  const timestamp = new Date().toISOString();
  console.info(`[${timestamp}] ℹ️ ${message}`, data);
};

// Export as named exports (already done above)
// Default export for convenience
const adminReport = {
  reportError,
  reportSuccess,
  reportInfo
};

export default adminReport;
